export const executeEveryReducerParts = (reducerParts, state, action) => {
  for (let i = 0; i < reducerParts.length; i += 1) {
    const reducerPartResult = reducerParts[i](state, action);

    if (reducerPartResult) {
      return reducerPartResult;
    }
  }

  return null;
};

export const sortAlphabeticallyInitialState = (messyInitialState) => {
  const initialStateSorted = Object.keys(messyInitialState).sort().reduce((acc, key) => (
    {
      ...acc, [key]: messyInitialState[key],
    }
  ), {});

  return initialStateSorted;
};
